import ControlArea from "components/Layout/ControlArea";
import React, { useEffect } from "react";
import Table from "./Table";
import shareIcon from "assets/svgs/socials.svg";
import { useDispatch } from "react-redux";
import { getSocialLinks } from "store/actions";
const Index = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSocialLinks());
  }, [dispatch]);

  return (
    <>
      <div className="users-wrap">
        <ControlArea
          btnTxt="اضافة  وسيلة تواصل جديدة"
          cardTxt="وسائل التواصل الاجتماعي"
          icon={shareIcon}
          url="/social-links/add"
        />
        <Table />
      </div>
    </>
  );
};

export default Index;
